import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./incomeGrid.module.css";
import { ArrowRight, Filter, Home, Search } from "react-feather";
import Helmet from "react-helmet";
import Footer from "../../../../../components/Footer";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../../../../components/Loader";
import axios from "axios";
import { TableLoader } from "../../../../../components/LoaderC";
import moment from "moment";
import {
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
} from "@mui/material";

import GridFilters from "./components/GridFilters";
import GridCards from "./components/GridCards";

const IncomeGrid = ({ handleView }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [contentLoading, setContentLoading] = useState(true);
  const [filterOpen, setFilterOpen] = useState(false);
  const [allData, setAllData] = useState([]);
  const [filterredData, setFilterredData] = useState([]);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(8);
  const [filterData, setFilterData] = useState({
    searchKey: "",
    property: "",
    apartment: "",
    payment_status: "",
    view: "",
  });
  const [propertyList, setPropertyList] = useState([]);
  const [apartmentList, setApartmentList] = useState([]);

  useEffect(() => {
    const fetchAllProperties = async () => {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });
      axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-list", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        let propertyData = response.data.data;

        propertyData = [{ value: "all", label: "All", apartments: [] }].concat(
          propertyData
        );
        setPropertyList(propertyData);

        if (localStorage.getItem("propertyFilterData")) {
          let filterPropertyId = localStorage.getItem("propertyFilterData");
          localStorage.removeItem("propertyFilterData");

          setFilterData((prev) => {
            return { ...prev, property: parseInt(filterPropertyId) };
          });

          let apartmentListTemp = [];
          propertyData?.map((i) => {
            if (i.value === parseInt(filterPropertyId)) {
              apartmentListTemp = i.apartments;
            }
            return null;
          });

          apartmentListTemp = [
            { value: "all", label: "All", apartments: [] },
          ].concat(apartmentListTemp);
          setApartmentList(apartmentListTemp);
        }

        if (localStorage.getItem("apartmentFilterData")) {
          let apartmentFilter = localStorage.getItem("apartmentFilterData");
          localStorage.removeItem("apartmentFilterData");
          apartmentFilter = parseInt(apartmentFilter);

          setFilterData((prev) => {
            return { ...prev, apartment: parseInt(apartmentFilter) };
          });
        }
      });
    };
    fetchAllProperties();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    async function getAllData() {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });

      axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/rent-rolls", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          setContentLoading(false);
          setAllData(response.data.data);
        })
        .catch((error) => {
          setContentLoading(false);
        });
    }
    getAllData();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    let filterredDataTemp = allData;

    if (filterData.searchKey !== "") {
      let inputVal = filterData.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredDataTemp = filterredDataTemp.filter((item) => {
        return (
          item.tenant_name.toLowerCase().includes(inputVal) ||
          item.property_name.toLowerCase().includes(inputVal) ||
          item.apt_name.toLowerCase().includes(inputVal) ||
          item.formatted_monthly_rent.toLowerCase().includes(inputVal) ||
          item.formatted_balance.toLowerCase().includes(inputVal)
        );
      });
    }

    if (filterData.property !== "" && filterData.property !== "all") {
      filterredDataTemp = filterredDataTemp.filter(
        (i) => i.property_id === filterData.property
      );
    }

    if (filterData.apartment !== "" && filterData.apartment !== "all") {
      filterredDataTemp = filterredDataTemp.filter(
        (i) => i.apt_id === filterData.apartment
      );
    }

    if (filterData.view !== "" && filterData.view !== "all") {
      if (filterData.view === "active") {
        filterredDataTemp = filterredDataTemp.filter(
          (i) => i.is_archived === 0
        );
      }
      if (filterData.view === "archived") {
        filterredDataTemp = filterredDataTemp.filter(
          (i) => i.is_archived === 1
        );
      }
    }

    if (
      filterData.payment_status !== "" &&
      filterData.payment_status !== "all"
    ) {
      filterredDataTemp = filterredDataTemp.filter(
        (i) => i.status === filterData.payment_status
      );
    }

    if (filterData.last_payment_date && filterData.last_payment_date !== "") {
      filterredDataTemp = filterredDataTemp.filter((i) => {
        var dateR = filterData.last_payment_date;
        if (
          moment(moment(i.last_payment_date).format("YYYY-MM-DD")).isBetween(
            moment(dateR[0]).format("YYYY-MM-DD"),
            moment(dateR[1]).format("YYYY-MM-DD"),
            undefined,
            []
          )
        ) {
          return true;
        }
        return false;
      });
    }

    setFilterredData(filterredDataTemp);
  }, [allData, filterData]);

  const selectProperty = (e) => {
    let apartmentListTemp = [];
    propertyList?.map((i) => {
      if (i.value === e) {
        apartmentListTemp = i.apartments;
      }
      return null;
    });

    apartmentListTemp = [{ value: "all", label: "All", apartments: [] }].concat(
      apartmentListTemp
    );
    setApartmentList(apartmentListTemp);
  };

  return (
    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          <div className="control-pane">
            {contentLoading && (
              <div className="Loader TableLoader">
                <TableLoader />
              </div>
            )}

            <div className={`${styles.Row}`}>
              {!contentLoading && (
                <>
                  <GridFilters
                    setPage={setPage.bind(this)}
                    setFilterData={setFilterData}
                    setFilterOpen={setFilterOpen}
                    filterOpen={filterOpen}
                    filterData={filterData}
                    selectProperty={selectProperty}
                    propertyList={propertyList}
                    apartmentList={apartmentList}
                    handleView={handleView}
                  />

                  <div className={`${styles.NotesRow}`}>
                    {filterredData.map((item, index) => {
                      return perPage === -1 ||
                        (index >= page * perPage &&
                          index < page * perPage + perPage) ? (
                        <GridCards item={item} index={index} />
                      ) : null;
                    })}

                    {filterredData.length > 0 && (
                      <div className="Pagination TablePaginationNew List">
                        <TablePagination
                          count={filterredData.length}
                          color="primary"
                          page={page}
                          rowsPerPage={perPage}
                          onPageChange={(e, v) => setPage(v)}
                          rowsPerPageOptions={[
                            { label: "4", value: 4 },
                            { label: "8", value: 8 },
                            { label: "16", value: 16 },
                            { label: "All", value: -1 },
                          ]}
                          onRowsPerPageChange={(e) => {
                            setPage(0);
                            setPerPage(e.target.value);
                          }}
                          labelRowsPerPage={"Payments per Page:"}
                        />
                      </div>
                    )}

                    {filterredData.length === 0 && (
                      <div className={`${styles.NoDataMain}`}>
                        <div className={`${styles.NoDataIMG}`}>
                          <img
                            src="/static/img/no-income.png"
                            alt="No Data"
                          />
                        </div>
                        <p className={`${styles.NoDataText}`}>
                          Income list is currently empty.
                        </p>
                        <p className={`${styles.NoDataTextSub}`}>
                          All your income entries will appear here once available.
                        </p>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncomeGrid;
